import { FC } from "react";

const ErrorView: FC = () => {
  return <h1>Error</h1>;
};

export default ErrorView;
